import type { Id } from '../../../aliases'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type SpaceGetApplicationsRequestPayload = {
  humanProxyId: Id
  spaceId: Id
}

export const SpaceGetApplicationsRequestPayloadSchema: CborSchema<SpaceGetApplicationsRequestPayload> =
  defineCborSchema<SpaceGetApplicationsRequestPayload>({
    humanProxyId: CborField({ key: 0 }),
    spaceId: CborField({ key: 1 }),
  })
